import { SortOrder } from 'antd/lib/table/interface';
import { getSortField } from '@/presentation/components/exception-issue-list/api';

export interface PageSetting  {
  page: number;
  pageSize: number;
  sortField?: string;
  sortType?: string;
}

export const getSortType = (order: SortOrder) => {
  switch (order) {
    case 'ascend':
      return 'ASC';
    case 'descend':
      return 'DESC';
    default:
      return undefined;
  }
};

// 问题列表默认模式不支持issue占比排序
export const filterSortField = (sortField: string) => {
  const field = getSortField(sortField);
  // issue占比
  const proportion = 'proportion';
  if (field.includes(proportion)) {
    return '';
  }
  return field;
};
